var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u8-page-container" },
    [
      _c(
        "el-row",
        { staticClass: "u8-search-bar" },
        [
          _c(
            "el-form",
            {
              ref: "formSearch",
              attrs: { inline: true, model: _vm.formSearch },
            },
            [
              _c(
                "el-col",
                { staticClass: "u8-border-r", attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "taskName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入任务名称", clearable: "" },
                        on: {
                          change: function ($event) {
                            return _vm.onSearchSubmit()
                          },
                        },
                        model: {
                          value: _vm.formSearch.taskName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSearch, "taskName", $$v)
                          },
                          expression: "formSearch.taskName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "u8-border-r", attrs: { span: 13 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "taskClass" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入任务脚本类",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onSearchSubmit()
                          },
                        },
                        model: {
                          value: _vm.formSearch.taskClass,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSearch, "taskClass", $$v)
                          },
                          expression: "formSearch.taskClass",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "u8-border-r", attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "taskGroup" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "任务分组",
                            clearable: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onSearchSubmit()
                            },
                          },
                          model: {
                            value: _vm.formSearch.taskGroup,
                            callback: function ($$v) {
                              _vm.$set(_vm.formSearch, "taskGroup", $$v)
                            },
                            expression: "formSearch.taskGroup",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: "ETL", label: "ETL任务" },
                          }),
                          _c("el-option", {
                            attrs: { value: "ANALYTICS", label: "统计任务" },
                          }),
                          _c("el-option", {
                            attrs: { value: "DEFAULT", label: "普通任务" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 2 } }, [
                _c(
                  "div",
                  { staticClass: "u8-search-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", icon: "el-icon-search" },
                        on: {
                          click: function ($event) {
                            return _vm.onSearchSubmit()
                          },
                        },
                      },
                      [_vm._v("搜 索")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", [
        _c("div", { attrs: { slot: "header" }, slot: "header" }, [
          _c("div", { staticClass: "u8-card-header" }, [
            _c("div", { staticClass: "u8-card-header__left" }, [
              _c("span", { staticClass: "u8-tab-item u8-tab-selected" }, [
                _vm._v("任务列表"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "u8-card-header__right" },
              [
                _c("u8-icon-btn", {
                  staticClass: "u8-mr-5",
                  attrs: { icon: "u8-add-box", tip: "添加任务" },
                  on: { click: _vm.addRow },
                }),
                _c("u8-icon-btn", {
                  attrs: { icon: "u8-refresh", tip: "刷新" },
                  on: { click: _vm.refreshRows },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "u8-card-body" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.data, stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "taskID",
                    label: "任务ID",
                    width: "250",
                  },
                }),
                _c("el-table-column", {
                  attrs: { sortable: "", prop: "taskName", label: "任务名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "u8-color-primary u8-clickable",
                              on: {
                                click: function ($event) {
                                  return _vm.showDetail(scope.$index, scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.taskName))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "taskGroup", label: "任务分组", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.taskGroup == "ETL"
                            ? _c("span", { staticClass: "u8-color-success" }, [
                                _vm._v("ETL任务"),
                              ])
                            : scope.row.taskGroup == "ANALYTICS"
                            ? _c("span", { staticClass: "u8-color-warning" }, [
                                _vm._v("统计任务"),
                              ])
                            : _c("span", [_vm._v("普通任务")]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "taskClass", label: "任务执行类" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "taskDescription", label: "任务描述" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "taskExpression", label: "Cron表达式" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "nextExecuteTime", label: "下次执行时间" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "taskStatus",
                    label: "执行状态",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.taskStatus == 1
                            ? _c(
                                "span",
                                { staticClass: "u8-color-success u8-bold" },
                                [_vm._v("等待")]
                              )
                            : scope.row.taskStatus == 2
                            ? _c(
                                "span",
                                { staticClass: "u8-color-warning u8-bold" },
                                [_vm._v("执行中")]
                              )
                            : _c(
                                "span",
                                { staticClass: "u8-color-gray u8-bold" },
                                [_vm._v("已禁用")]
                              ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.editRow(scope.$index, scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-dropdown",
                            { staticClass: "u8-ml-10" },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _vm._v(" 更多操作 "),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showAlarms(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("配置告警")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.triggerRow(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("立即触发")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.pauseRow(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("暂停任务")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.resumeRow(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("恢复任务")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      staticStyle: { color: "#F56C6C" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.deleteRow(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除任务")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "u8-card-footer" },
          [
            _c("el-pagination", {
              attrs: {
                small: "",
                layout: "->, sizes, prev, pager, next, total",
                total: _vm.pagination.total,
                "page-size": _vm.pagination.pageSize,
                "current-page": _vm.pagination.currentPage,
                "page-sizes": [10, 20, 30, 40, 50],
              },
              on: {
                "current-change": _vm.paginationCurrentChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogFormVisible,
            width: _vm.dialogWidth,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            modal: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "任务名称", prop: "taskName" } },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      clearable: "",
                      placeholder: "请输入任务名称",
                    },
                    model: {
                      value: _vm.form.taskName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskName", $$v)
                      },
                      expression: "form.taskName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务分组", prop: "taskGroup" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "请选择任务分组",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.taskGroup,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskGroup", $$v)
                        },
                        expression: "form.taskGroup",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "ETL", label: "ETL任务" },
                      }),
                      _c("el-option", {
                        attrs: { value: "ANALYTICS", label: "统计任务" },
                      }),
                      _c("el-option", {
                        attrs: { value: "DEFAULT", label: "其他任务" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务脚本类", prop: "taskClass" } },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      clearable: "",
                      placeholder: "请输入作业任务完整类名",
                    },
                    model: {
                      value: _vm.form.taskClass,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskClass", $$v)
                      },
                      expression: "form.taskClass",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    "margin-top": "-10px",
                    "margin-bottom": "0px",
                  },
                },
                [
                  _c(
                    "span",
                    { staticStyle: { color: "#E6A23C", "font-size": "12px" } },
                    [
                      _vm._v(
                        "corn从左到右（用空格隔开）：秒 分 小时 月份中的日期 月份 星期中的日期 年份"
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Cron表达式", prop: "taskExpression" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        "auto-complete": "off",
                        clearable: "",
                        placeholder:
                          "点击右边按钮,可以进行Cron表达式可视化编辑",
                      },
                      model: {
                        value: _vm.form.taskExpression,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskExpression", $$v)
                        },
                        expression: "form.taskExpression",
                      },
                    },
                    [
                      !_vm.showCronBox
                        ? _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-arrow-up",
                              title: "打开图形配置",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showCronBox = true
                              },
                            },
                            slot: "append",
                          })
                        : _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-arrow-down",
                              title: "关闭图形配置",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showCronBox = false
                              },
                            },
                            slot: "append",
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    "margin-top": "-10px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _vm.showCronBox
                    ? _c("cron", {
                        model: {
                          value: _vm.form.taskExpression,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "taskExpression", $$v)
                          },
                          expression: "form.taskExpression",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "错过策略", prop: "misfireType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "请选择任务错误执行时的处理策略",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.misfireType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "misfireType", $$v)
                        },
                        expression: "form.misfireType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "0", label: "不做任何处理" },
                      }),
                      _c("el-option", {
                        attrs: { value: "1", label: "立即触发一次" },
                      }),
                      _c("el-option", {
                        attrs: { value: "2", label: "依次执行所有错过的触发" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务参数", prop: "taskParams" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autocomplete: "off",
                      placeholder: "请输入任务参数,json格式",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.taskParams,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskParams", $$v)
                      },
                      expression: "form.taskParams",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "开始时间", prop: "taskBeginTime" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: "请选择首次开始时间",
                    },
                    model: {
                      value: _vm.form.taskBeginTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskBeginTime", $$v)
                      },
                      expression: "form.taskBeginTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "最大执行时间", prop: "maxTimeSecs" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        autocomplete: "off",
                        placeholder: "执行时间超过该值，将触发报警",
                      },
                      model: {
                        value: _vm.form.maxTimeSecs,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "maxTimeSecs", $$v)
                        },
                        expression: "form.maxTimeSecs",
                      },
                    },
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticClass: "u8-ml-10",
                          attrs: { slot: "suffix" },
                          on: { command: _vm.handleMaxTimeCommand },
                          slot: "suffix",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "el-dropdown-link u8-mr-5" },
                            [
                              _vm.currMaxTimeUnit == "hour"
                                ? _c("label", [_vm._v("时")])
                                : _vm._e(),
                              _vm.currMaxTimeUnit == "min"
                                ? _c("label", [_vm._v("分")])
                                : _vm._e(),
                              _vm.currMaxTimeUnit == "sec"
                                ? _c("label", [_vm._v("秒")])
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "hour" } },
                                [_vm._v("时")]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "min" } },
                                [_vm._v("分")]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "sec" } },
                                [_vm._v("秒")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务描述", prop: "taskDescription" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", clearable: "" },
                    model: {
                      value: _vm.form.taskDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskDescription", $$v)
                      },
                      expression: "form.taskDescription",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("form")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "user-detail-panel",
          attrs: {
            title: "详情信息",
            size: _vm.dialogWidth,
            withHeader: false,
            "append-to-body": "",
            visible: _vm.isShowDetail,
            direction: _vm.drawerDirection,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDetail = $event
            },
          },
        },
        [
          _c(
            "u8-container",
            [
              _c(
                "el-card",
                { staticClass: "u8-detail-panel", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "u8-clearfix u8-detail-panel__header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "u8-detail-panel__title" }, [
                        _vm._v("任务详情"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "u8-detail-panel__close",
                          on: {
                            click: function ($event) {
                              _vm.isShowDetail = false
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-close" })]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "u8-detail-panel__body" },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "u8-right-detail",
                          attrs: {
                            "label-position": "left",
                            "label-width": "100px",
                            "label-suffix": " :",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "u8-detail-panel__subbody" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务名称" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.detailForm.taskName)),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务执行状态" } },
                                [
                                  _vm.detailForm.taskStatus == 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "u8-color-success u8-bold",
                                        },
                                        [_vm._v("等待")]
                                      )
                                    : _vm.detailForm.taskStatus == 2
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "u8-color-warning u8-bold",
                                        },
                                        [_vm._v("执行中")]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "u8-color-gray u8-bold",
                                        },
                                        [_vm._v("已禁用")]
                                      ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务状态" } },
                                [
                                  _vm.detailForm.taskPauseStatus == 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "u8-color-error u8-bold",
                                        },
                                        [_vm._v("已暂停")]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "u8-color-success u8-bold",
                                        },
                                        [_vm._v("正常")]
                                      ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务分组" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.detailForm.taskGroup)),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务脚本类" } },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "bold" } },
                                    [_vm._v(_vm._s(_vm.detailForm.taskClass))]
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "Cron表达式" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.detailForm.taskExpression)
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务参数" } },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        title: "任务参数",
                                        placement: "top-end",
                                        width: "400",
                                        trigger: "hover",
                                        content: _vm.detailForm.taskParams,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-top": "3px !important",
                                          },
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("ellipsis")(
                                                _vm.detailForm.taskParams
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务描述" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.detailForm.taskDescription)
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "首次开始时间" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.detailForm.startTime)),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "错过策略" } },
                                [
                                  _vm.detailForm.misfireType == 0
                                    ? _c("span", [_vm._v("不做任何处理")])
                                    : _vm.detailForm.misfireType == 1
                                    ? _c("span", [_vm._v("立即触发一次")])
                                    : _vm._e(),
                                  _vm.detailForm.misfireType == 2
                                    ? _c("span", [
                                        _vm._v("依次执行所有错过的触发"),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "最大执行时间" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.detailForm.maxTimeSecs) + "秒"
                                    ),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "u8-ml-20 u8-color-warning",
                                    },
                                    [_vm._v("(执行时间超过该值，将触发报警)")]
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "下次执行时间" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.detailForm.nextExecuteTime)
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "u8-detail-panel__subheader" },
                            [
                              _c(
                                "span",
                                { staticClass: "u8-detail-panel__subtitle" },
                                [_vm._v("最近执行记录")]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "u8-detail-panel__subbody" },
                            [
                              _c(
                                "HelperBox",
                                {
                                  staticStyle: {
                                    "margin-top": "10px !important",
                                  },
                                },
                                [
                                  _vm._v(
                                    " 这里列出的是该任务近一个90天内的执行记录，如果需查询更久的执行记录，请在日志数据中进行查询 "
                                  ),
                                ]
                              ),
                              _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.logLoading,
                                      expression: "logLoading",
                                    },
                                  ],
                                  staticClass: "user-detail-orders",
                                  staticStyle: { width: "100%" },
                                  attrs: { stripe: "", data: _vm.taskLogs },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { type: "expand" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            _c(
                                              "el-form",
                                              {
                                                staticClass: "u8-right-detail",
                                                attrs: {
                                                  "label-position": "right",
                                                  "label-suffix": " :",
                                                  "label-width": "90px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-row",
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "任务脚本类",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row
                                                                .taskClass
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-row",
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "Cron表达式",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row
                                                                .taskExpression
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-row",
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "完成时间",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.endAt
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                props.row.status == -1
                                                  ? _c(
                                                      "el-row",
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label: "错误信息",
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.row
                                                                    .error
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "执行时间",
                                      prop: "startAt",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "耗时(s)",
                                      prop: "costMillis",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  (
                                                    scope.row.costMillis / 1000
                                                  ).toFixed(1)
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "执行结果",
                                      prop: "status",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.status == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "u8-color-success u8-bold",
                                                  },
                                                  [_vm._v("成功")]
                                                )
                                              : scope.row.status == 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "u8-color-warning u8-bold",
                                                  },
                                                  [_vm._v("执行中")]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "u8-color-error u8-bold",
                                                  },
                                                  [_vm._v("失败")]
                                                ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "u8-mt-10" },
                                [
                                  _c("el-pagination", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.logPagination.total >
                                          _vm.logPagination.pageSize,
                                        expression:
                                          "logPagination.total > logPagination.pageSize",
                                      },
                                    ],
                                    attrs: {
                                      small: "",
                                      layout: "->, prev, pager, next, total",
                                      total: _vm.logPagination.total,
                                      "page-size": _vm.logPagination.pageSize,
                                      "current-page":
                                        _vm.logPagination.currentPage,
                                    },
                                    on: {
                                      "current-change":
                                        _vm.logPaginationCurrentChange,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "alarm-dialog",
          attrs: {
            visible: _vm.alarmDialogVisible,
            width: _vm.alarmDialogWidth,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.alarmDialogVisible = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { attrs: { flex: "" } }, [
              _c(
                "div",
                { staticClass: "u8-mb-5", attrs: { "flex-box": "1" } },
                [
                  _c(
                    "span",
                    { staticClass: "u8-tab-item u8-pb-15 u8-tab-selected" },
                    [_vm._v("告警配置列表")]
                  ),
                  _c("span", { staticClass: "u8-tab-item u8-pl-5" }, [
                    _vm._v(_vm._s(_vm.alarmTitle)),
                  ]),
                ]
              ),
              _c(
                "div",
                { attrs: { "flex-box": "0" } },
                [
                  _c("u8-icon-btn", {
                    staticClass: "u8-mr-50",
                    attrs: { icon: "u8-add-box", tip: "添加告警配置" },
                    on: { click: _vm.addAlarm },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("AlarmList", {
            ref: "alarms",
            staticClass: "u8-ml-20 u8-mr-20",
            attrs: {
              taskID: _vm.alarmInfo.taskID,
              taskUniID: _vm.alarmInfo.taskUniID,
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }